export enum FeatureNameEnum {
  BenefitManagement,
  BenefitManagementMenu,
  VoterVoice,
  SalesOpportunities,
  BigCommerce,
  Projects,
}
